import { pathOr } from 'ramda';

import { IState } from '../../store';

export const selectNearbyNewbuildingsMapUrl = (state: IState): string | null => {
  const url = pathOr<string | null>(null, ['offerData', 'newObject', 'nearbyNewbuildingsMapUrl'], state);

  return url;
};
